module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "jira",
    on: {
      "click": _vm.launchCollector
    }
  }, [_vm._v("Feedback")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38525bc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Jira.vue
// module id = 131
// module chunks = 0